// extracted by mini-css-extract-plugin
module.exports = {"blu":"india_blu__gP7cK","textclr":"india_textclr__1kLxz","loading":"india_loading__28mdt"};